export class HyperlinkDto {

  public id!: string;
  public reference!: string;
  public prime!: boolean;
  public label: string | undefined;

  constructor(init?: Partial<HyperlinkDto> | undefined) {
    Object.assign(this, init);
  }
}
